__turbopack_context__.v({
  "container": "footer-module-scss-module__9OLJ2W__container",
  "copyright": "footer-module-scss-module__9OLJ2W__copyright",
  "divider": "footer-module-scss-module__9OLJ2W__divider",
  "footer": "footer-module-scss-module__9OLJ2W__footer",
  "heart": "footer-module-scss-module__9OLJ2W__heart",
  "inner": "footer-module-scss-module__9OLJ2W__inner",
  "logoBlock": "footer-module-scss-module__9OLJ2W__logoBlock",
  "logoIcon": "footer-module-scss-module__9OLJ2W__logoIcon",
  "logoText": "footer-module-scss-module__9OLJ2W__logoText",
  "socialLink": "footer-module-scss-module__9OLJ2W__socialLink",
  "socials": "footer-module-scss-module__9OLJ2W__socials",
  "tagline": "footer-module-scss-module__9OLJ2W__tagline",
});
